import * as S from './styles'
import ImgMock from '../../assets/products/negociacoes/thumbnail.png'
import MediaMatch from '../MediaMatch'
import {
  convertDecimalCurrency,
  formatarParaPorcentagem
} from '../../utils/utils'
import { useEffect } from 'react'

const Table = ({ products, type, print, filiais = () => undefined }) => {
  return (
    <>
      <S.Wrapper print={print}>
        <div className="table-desktop" greaterThan="large">
          {filiais(products)?.map((filial) => {
            return (
              <>
                <div className="filiais">
                  Produtos serão entregues por <strong>{filial.filial}</strong>
                </div>

                <S.TableDesktop print={print}>
                  {/* CABEÇALHO */}
                  <thead>
                    <tr>
                      <th></th>
                      <th>Produto</th>
                      <th>Qtd</th>
                      <th>Preço Normal</th>
                      <th>Preço Venda</th>

                      {type === 'n' ? (
                        <>
                          <th>Preço Sugerido</th>
                          <th>Preço Aprovado</th>
                        </>
                      ) : (
                        <th>Desconto</th>
                      )}

                      {products.some((product) => product.PossuiIPI) && (
                        <>
                          <th>IPI%</th>
                          <th>Total IPI</th>
                        </>
                      )}
                      <th>Total</th>
                    </tr>
                  </thead>
                  {/* BODY */}
                  <tbody>
                    {products
                      ?.filter((item) => item.Filial === filial.filial)
                      .map((item, index) => {
                        return (
                          <tr key={index}>
                            <td classNameName="text-center">
                              <img
                                src={`${process.env.REACT_APP_URL_IMAGES}${item?.IdObjetoMedia}`}
                                alt="Tabela de Produtos"
                              />
                            </td>
                            <td>{item.DescricaoResumida}</td>
                            <td>{item.Quantidade}</td>
                            <td>{convertDecimalCurrency(item.PrecoNormal)}</td>
                            <td>{convertDecimalCurrency(item.PrecoVenda)}</td>
                            {type === 'n' ? (
                              <>
                                <td>
                                  {convertDecimalCurrency(
                                    item.ValorSugestaoCliente
                                  )}
                                </td>
                                <td>
                                  {item.ValorNegociadoAprovacao === 0 ||
                                  item.ValorNegociadoAprovacao === null
                                    ? '-'
                                    : convertDecimalCurrency(
                                        item.ValorNegociadoAprovacao
                                      )}
                                </td>
                              </>
                            ) : (
                              <td>{convertDecimalCurrency(item.Desconto)}</td>
                            )}
                            {products.some((product) => product.PossuiIPI) && (
                              <>
                                {item.ValorAliquotaIPI ? (
                                  <td>
                                    {formatarParaPorcentagem(
                                      item.ValorAliquotaIPI
                                    )}
                                  </td>
                                ) : (
                                  <td>-</td>
                                )}
                                {item.ValorIPI ? (
                                  <td>
                                    {convertDecimalCurrency(item.ValorIPI)}
                                  </td>
                                ) : (
                                  <td>-</td>
                                )}
                              </>
                            )}

                            <td>
                              <strong>
                                {convertDecimalCurrency(item.ValorTotal)}
                              </strong>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </S.TableDesktop>
              </>
            )
          })}
        </div>

        <div className="table-mobile" lessThan="large">
          {filiais(products)?.map((filial) => {
            return (
              <>
                <div className="filiais">
                  Produtos serão entregues por <strong>{filial.filial}</strong>
                </div>

                <S.TableMobile>
                  {products
                    ?.filter((item) => item.Filial === filial.filial)
                    .map((item, index) => {
                      return (
                        <S.ProductCard key={index}>
                          <S.ProductCardHeader>
                            <div className="negociacoes-product-card-columns">
                              <div className="negociacoes-product-card-column">
                                <img
                                  src={`${process.env.REACT_APP_URL_IMAGES}${item?.IdObjetoMedia}`}
                                  alt=""
                                />
                              </div>
                              <div className="negociacoes-product-card-column">
                                <strong>{item.DescricaoResumida}</strong>
                                {item.Quantidade}{' '}
                                {item.Quantidade > 1 ? 'unidades' : 'unidade'}
                              </div>
                            </div>
                          </S.ProductCardHeader>

                          <S.ProductCardList>
                            <S.ProductCardItem>
                              <div className="negociacoes-product-card-columns">
                                <div className="negociacoes-product-card-column">
                                  Preço Normal
                                </div>
                                <div className="negociacoes-product-card-column">
                                  {convertDecimalCurrency(item.PrecoNormal)}
                                </div>
                              </div>
                            </S.ProductCardItem>
                            <S.ProductCardItem>
                              <div className="negociacoes-product-card-columns">
                                <div className="negociacoes-product-card-column">
                                  Preço Venda
                                </div>
                                <div className="negociacoes-product-card-column">
                                  {convertDecimalCurrency(item.PrecoVenda)}
                                </div>
                              </div>
                            </S.ProductCardItem>

                            {type === 'n' ? (
                              <>
                                <S.ProductCardItem>
                                  <div className="negociacoes-product-card-columns">
                                    <div className="negociacoes-product-card-column">
                                      Preço Sugerido
                                    </div>
                                    <div className="negociacoes-product-card-column">
                                      {convertDecimalCurrency(
                                        item.ValorSugestaoCliente
                                      )}
                                    </div>
                                  </div>
                                </S.ProductCardItem>
                                <S.ProductCardItem>
                                  <div className="negociacoes-product-card-columns">
                                    <div className="negociacoes-product-card-column">
                                      Preço Aprovado
                                    </div>
                                    <div className="negociacoes-product-card-column">
                                      {convertDecimalCurrency(
                                        item.ValorNegociadoAprovacao
                                      )}
                                    </div>
                                  </div>
                                </S.ProductCardItem>
                              </>
                            ) : (
                              <S.ProductCardItem>
                                <div className="negociacoes-product-card-columns">
                                  <div className="negociacoes-product-card-column">
                                    Desconto
                                  </div>
                                  <div className="negociacoes-product-card-column">
                                    {convertDecimalCurrency(item.Desconto)}
                                  </div>
                                </div>
                              </S.ProductCardItem>
                            )}
                            {products.some((product) => product.PossuiIPI) && (
                              <>
                                <S.ProductCardItem>
                                  <div className="negociacoes-product-card-columns">
                                    <div className="negociacoes-product-card-column">
                                      IPI%
                                    </div>
                                    <div className="negociacoes-product-card-column">
                                      {item.ValorAliquotaIPI
                                        ? formatarParaPorcentagem(
                                            item.ValorAliquotaIPI
                                          )
                                        : '-'}
                                    </div>
                                  </div>
                                </S.ProductCardItem>
                                <S.ProductCardItem>
                                  <div className="negociacoes-product-card-columns">
                                    <div className="negociacoes-product-card-column">
                                      Total IPI
                                    </div>
                                    <div className="negociacoes-product-card-column">
                                      {item.ValorIPI
                                        ? convertDecimalCurrency(item.ValorIPI)
                                        : '-'}
                                    </div>
                                  </div>
                                </S.ProductCardItem>
                              </>
                            )}

                            <S.ProductCardItem>
                              <div className="negociacoes-product-card-columns">
                                <div className="negociacoes-product-card-column">
                                  Total
                                </div>
                                <div className="negociacoes-product-card-column">
                                  {convertDecimalCurrency(item.ValorTotal)}
                                </div>
                              </div>
                            </S.ProductCardItem>
                          </S.ProductCardList>
                        </S.ProductCard>
                      )
                    })}
                </S.TableMobile>
              </>
            )
          })}
        </div>
      </S.Wrapper>
    </>
  )
}

export default Table
